import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
type SourceChipProps = {
  /** The citation as written — "S1", or "S1 p. 4" with a locator — used as the chip label. */
  children?: ReactNode;
};

// Renders a Percy `[S#]` citation as an inline chip. Mirrors the inline-code/IdBadge
// pill family (mono, accent, bordered) so citations read as first-class references.
const SourceChip = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <span data-source-chip="true" className="inline-flex items-center align-baseline font-mono text-[13px] text-accent bg-secondary border border-tertiary rounded px-1 py-0">{children}</span>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default SourceChip;